import { render, staticRenderFns } from "./Spotlight.vue?vue&type=template&id=a4a6cf30&scoped=true"
import script from "./Spotlight.vue?vue&type=script&lang=js"
export * from "./Spotlight.vue?vue&type=script&lang=js"
import style0 from "./Spotlight.vue?vue&type=style&index=0&id=a4a6cf30&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a6cf30",
  null
  
)

export default component.exports